var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ModifierBuilder, OrderItemBuilder, OrderManager } from 'aigens-ng-core';
import { ChangeDetectorRef, Injector, OnDestroy, OnInit } from '@angular/core';
import { NavParams, ToastController } from '@ionic/angular';
import { RouteTable } from '../../../core/route-table';
import { MobileBasePage } from '../../../core/base/mobile-base-page';
import { ModifierDialog } from '../../../dialogs/modifier/modifier';
import { ModifierItemSelectPageModal } from './../modifier-item-select-modal/modifier-item-select-modal';
var MultiStepComboPage = /** @class */ (function (_super) {
    __extends(MultiStepComboPage, _super);
    function MultiStepComboPage(injector, modalNavParams, toastCtrl, cd) {
        var _this = _super.call(this, injector) || this;
        _this.modalNavParams = modalNavParams;
        _this.toastCtrl = toastCtrl;
        _this.cd = cd;
        // setting flags:
        _this.isAutoPickup = false;
        _this.preselectItem = false;
        _this.groupIdMap = {};
        // isGroupCompleted = {};
        _this.builderGroupsCount = 0;
        _this.itemMap = {};
        _this.total = 0;
        _this.modifiable = false;
        _this.missing = false;
        // hasSelectedModifiers: boolean;
        // selectedModifiersName: string;
        _this.itemGroupMap = {};
        _this.sameTitleItems = {};
        _this.isTitleGroupExpand = {};
        _this.openedTitleGroup = {};
        _this.titles = {};
        _this.isAutoPickupHasModifier = false;
        // TODO: make it a function?
        // auto pick groups have incomplete modifier?
        _this.isAutoPickupModifierCompleted = false;
        // preselectItem
        _this.orderMap = new Map();
        _this.noNeedConfirm = {};
        // isAutoPickGroupFunc = this.isAutoPickGroup;
        _this.screenWidthUnit = 0;
        _this.autoPickupGroups = [];
        _this.nonAutoPickupGroups = [];
        _this.modifierShown = false;
        // this.edit = this.getNavParams('edit');
        // this.store = this.getNavParams('store');
        console.log('toggle set menu page construction');
        _this.store = _this.modalNavParams.get('multi_store');
        _this.edit = _this.modalNavParams.get('multi_edit');
        _this.dismissCallback = _this.modalNavParams.get('multi_dismissCallback');
        if (_this.store) {
            _this.preselectItem = _this.settings.preselectItem;
            _this.isAutoPickup = _this.settings.autoPickup;
        }
        var groups;
        var mainItem;
        _this.builder = new OrderItemBuilder(_this.store);
        if (!_this.edit) {
            // this.category = this.getNavParams('category');
            _this.category = _this.modalNavParams.get('multi_category');
            // category.groups
            // groups = this.getNavParams('groups');
            // mainItem = this.getNavParams('item');
            groups = _this.modalNavParams.get('multi_groups');
            mainItem = _this.modalNavParams.get('multi_item');
        }
        else {
            var origins = _this.builder.findOrigins(_this.edit);
            _this.category = origins.category;
            groups = origins.groups;
            mainItem = origins.item;
        }
        _this.builder.category = _this.category;
        // this.isGroupCompleted = {};
        _this.isExpand = [];
        // make deep copy
        // const [tmpItem, tmpGroups] = this.menuService.clone(mainItem, groups, new Date().getTime());
        // mainItem = tmpItem;
        // groups = tmpGroups;
        if (mainItem.groups && mainItem.groups.length > 0) {
            _this.mainGroup = groups[0]; // buger页的所有数据
            groups = mainItem.groups; // 当前特定bugger的所有items Groups
            _this.mainItem = mainItem;
            _this.mainItem.quantity = 1;
        }
        else {
            // var choices = groups[0].choices;
            var min = groups[0].min;
            var max = groups[0].max;
            var choices = groups[0].choices;
            if ((max === 1 && min === 1) || choices === 1) {
                _this.mainGroup = groups[0];
                groups = groups.slice(1);
                _this.mainItem = mainItem;
                _this.mainItem.quantity = 1;
            }
        }
        _this.mainItemImage = _this.mainItem.getImage('default', 200, false);
        if (_this.store) {
            _this.handleOrderManager();
        }
        console.log('111', groups);
        // DEEP CLONE!
        groups = groups && groups.filter(function (group) {
            console.log('111', _this.store, _this.category, group, _this.orderManager.order.takeout, Date.now());
            return _this.menuManager.isAvailableGroup(_this.store, _this.category, group, _this.orderManager.order.takeout, Date.now(), false);
        });
        _this.groups = groups;
        console.log(_this.groups);
        // if (!this.edit) {
        _this.builder.setItem(_this.mainGroup, _this.mainItem, 0);
        // }
        if (_this.edit) {
            _this.builder.transferSubitems(_this.edit, _this.groups);
            // build all no need subitem group
            for (var j = 0; j < _this.groups.length; j++) {
                var matched = false;
                for (var i = 0; i < _this.edit.groups.length; i++) {
                    // pass main item
                    if (i !== 0) {
                        if (_this.groups[j].id === _this.edit.groups[i].id) {
                            // console.log("matched and put", this.groups[j].name);
                            matched = true;
                            break;
                        }
                    }
                }
                if (!matched) {
                    // console.log('i am putting null clickedNoNeed: ', this.groups[j].name);
                    _this.noNeedConfirm[_this.groups[j].id] = true;
                    _this.builder.clearItems(j + 1);
                    _this.builder.build();
                }
            }
        }
        var orderItem = _this.builder.build();
        _this.isExpand[_this.groups[0].id] = true;
        // this.isExpand[this.groups[0].id] = !this.preselectItem;
        _this.modifierBuilder = new ModifierBuilder(_this.store, orderItem);
        if (_this.edit) {
            _this.modifierBuilder.transfer(_this.edit);
            _this.modifierBuilder.build();
        }
        _this.flatten();
        _this.total = _this.mainItem.price;
        console.log(_this.groups);
        _this.screenWidthUnit = _this.platform.width() / 100;
        if (_this.screenWidthUnit > 4.75) {
            /// Largest screen with : 475px
            _this.screenWidthUnit = 4.75;
        }
        return _this;
    }
    MultiStepComboPage.prototype.checkDifference = function (index, input) {
        return input['id'];
    };
    MultiStepComboPage.prototype.ionViewWillEnter = function () {
        _super.prototype.ionViewWillEnter.call(this);
        // console.log('group', this.groups);
    };
    MultiStepComboPage.prototype.handleOrderManager = function () {
        if (this.multOrderManager.enableMutlOrder) {
            this.settingMultOrderManager();
        } /*else if (this.orderManager.isEmpty()) {
            this.orderManager.createOrder(this.store.id, null, null, null, this.store);
        }
        this.orderManager.settingOrderType(this.orderManager.mode);*/
    };
    MultiStepComboPage.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        console.log('on init');
        this.handleModifier();
        this.checkAutoPickupHasModifier();
        this.checkAutoPickupModifierCompleted();
        this.cd.detectChanges();
        for (var key in this.isExpand) {
            if (this.isExpand[key]) {
                this.preOpenTitleGroup(key, -1);
            }
        }
    };
    MultiStepComboPage.prototype.ngOnDestroy = function () {
        // this.groups.forEach((group) => {
        //         group.items.forEach((item) => {
        //                 item['groupIndex'] = null;
        //         });
        // });
    };
    // TODO: merge this with flatten
    // check if mainitems/auto pick up items has modifiers, should add pre-selected ones
    MultiStepComboPage.prototype.checkAutoPickupHasModifier = function () {
        this.isAutoPickupHasModifier = false;
        // fist check if main item is selected and check itself has modiifer or not
        if (this.builder.groups && this.builder.groups[0] && this.mainItem) {
            if (this.builder.groups[0].items[0] && this.builder.groups[0].items[0].id === this.mainItem.id) {
                console.log('this.builder.groups[0].itemGroupMap[0].id', this.builder.groups[0].items[0].id);
                for (var _i = 0, _a = this.mainItem.mgroups; _i < _a.length; _i++) {
                    var mgroup = _a[_i];
                    if (mgroup) {
                        this.isAutoPickupHasModifier = true;
                        break;
                    }
                }
            }
        }
        if (this.isAutoPickupHasModifier) {
            return;
        }
        var mgroups = this.mainItem && this.mainItem.mgroups || [];
        this.isAutoPickupHasModifier = mgroups.length > 0;
        // second check if autopick group need modifier or not
        for (var i = 0; i < this.groups.length; i++) {
            if (this.isAutoPickGroup(this.groups[i])) {
                if (this.hasRequiredModifier(this.groups[i].items)) {
                    this.isAutoPickupHasModifier = true;
                    return;
                }
            }
        }
        console.log('this.isExpand', this.isExpand);
    };
    MultiStepComboPage.prototype.dismissModal = function () {
        // canActivate(
        //     next: ActivatedRouteSnapshot,
        //     state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        //     console.log('item guard');
        //     if ((this.navigationService.lastParams && (this.navigationService.lastParams['edit'] || this.navigationService.lastParams['item'])) || this.navigationService.poping) {
        //         return true;
        //     } else {
        //         // this.navController.pop().then(data => {
        //         //     console.log('pop ok', data);
        //         // }, error => {
        //         //     console.log('cannot pop', error);
        //         const t = this.navigationService.getRootPageUrl();
        //         console.log('home guard', t);
        //         if (t) {
        //             // TODO: not allowed to enter target root. go to parent route?
        //             this.navController.setDirection('root');
        //             this.router.navigate([this.navigationService.getRootPageUrl()]);
        //         }
        //     }
        //     return false;
        // }
        this.modalController.dismiss();
    };
    MultiStepComboPage.prototype.backButtonClick = function (toRoot, route) {
        // if the outlet has page stack, pop
        // else redirect to root page
        console.log('on back button click');
        console.log('is navigating?', this.navigationService.navigating);
        if (!toRoot) {
            console.log('back by pop');
            this.googleAnalyticEventTrack('back');
            // if (this.backByLocation) {
            //     this.location.back();
            //     window.onpopstate
            // window.history.replaceState({},this.location.path());
            // } else {
            if (!this.navigationService.poping) {
                this.navigationService.lastParams = null;
                console.log('pop start');
                this.navigationService.popPage();
            }
            else {
                console.log('pop is in progress, try again later');
            }
            // }
        }
        else {
            this.googleAnalyticEventTrack('back');
            console.log('back by navigate to root');
            this.navigationService.popToRoot();
        }
        // this.stackController.pop(0)
        // this.navController.goBack();
        // this.navController.pop();
    };
    // TODO: merge with the function above
    MultiStepComboPage.prototype.checkAutoPickupModifierCompleted = function () {
        console.log('checking isAutoPickupmodifiercompleted');
        var completed = true;
        console.log('this.builder.groups', this.builder.groups);
        console.log('this.mainItem', this.mainItem);
        // fist check if main item is selected and check itself has modiifer or not
        if (this.builder.groups && this.builder.groups[0] && this.mainItem) {
            if (this.builder.groups[0].items[0] && this.builder.groups[0].items[0].id === this.mainItem.id) {
                for (var _i = 0, _a = this.mainItem.mgroups; _i < _a.length; _i++) {
                    var mgroup = _a[_i];
                    if (mgroup.min > 0) {
                        var mgroups = this.builder.groups[0].items[0].mgroups;
                        if (mgroups) {
                            for (var i = 0; i < mgroups.length; i++) {
                                var quantities = 0;
                                for (var _b = 0, _c = mgroups[i].items; _b < _c.length; _b++) {
                                    var tmpItem = _c[_b];
                                    quantities += 1 * tmpItem.quantity;
                                }
                                if (mgroups[i].min > 0) {
                                    completed = quantities >= mgroups[i].min;
                                    if (!completed) {
                                        return;
                                    }
                                }
                            }
                        }
                        else {
                            completed = false;
                        }
                    }
                }
            }
        }
        for (var i = 0; i < this.mainItem.groups.length; i++) {
            console.log('i', i);
            // check autopickup group with mainItem to see if it needs modifier
            if (this.isAutoPickGroup(this.mainItem.groups[i])) {
                console.log('mainitem.group', this.mainItem.groups[i]);
                for (var _d = 0, _e = this.mainItem.groups[i].items; _d < _e.length; _d++) {
                    var item = _e[_d];
                    if (item.mgroups.length > 0) {
                        console.log('this.builder.groups', this.builder.groups);
                        console.log('this.builder.groups[i]', this.builder.groups[i + 1]);
                        var isItemMgroupMinGreaterThanZero = false;
                        if (!this.builder.groups[i + 1] || !this.builder.groups[i + 1].items || !this.builder.groups[i + 1].items[0] || !this.builder.groups[i + 1].items[0].mgroups) {
                            for (var _f = 0, _g = item.mgroups; _f < _g.length; _f++) {
                                var itemMgroup = _g[_f];
                                if (itemMgroup.min > 0) {
                                    isItemMgroupMinGreaterThanZero = true;
                                    break;
                                }
                            }
                            if (isItemMgroupMinGreaterThanZero) {
                                completed = false;
                                return;
                            }
                            else {
                                if (completed) {
                                    this.isAutoPickupModifierCompleted = true;
                                    return;
                                }
                            }
                        }
                        for (var j = 0; j < this.builder.groups[i + 1].items[0].mgroups.length; j++) {
                            var quantities = 0;
                            for (var _h = 0, _j = this.builder.groups[i + 1].items[0].mgroups[j].items; _h < _j.length; _h++) {
                                var tmpItem = _j[_h];
                                quantities += 1 * tmpItem.quantity;
                            }
                            if (item.mgroups[0].min > 0) {
                                completed = quantities >= item.mgroups[0].min;
                                if (!completed) {
                                    return;
                                }
                            }
                        }
                    }
                    else {
                        completed = true;
                    }
                }
            }
        }
        if (completed) {
            this.isAutoPickupModifierCompleted = true;
        }
        console.log('isAutoPickupModifierCompleted', this.isAutoPickupModifierCompleted);
    };
    MultiStepComboPage.prototype.toggleGroupExpansion = function (groupId) {
        var _this = this;
        console.log('toggleGroupExpansion:', groupId);
        if (!this.isExpand[groupId]) {
            this.isExpand[groupId] = true; // 展开
            setTimeout(function () {
                _this.preOpenTitleGroup(groupId, -1);
            }, 100);
        }
        else {
            this.isExpand[groupId] = false; // 收缩
            this.openedTitleGroup[groupId] = null;
            for (var key in this.isTitleGroupExpand[groupId]) {
                this.isTitleGroupExpand[groupId][key] = false;
            }
        }
        this.cd.detectChanges();
    };
    MultiStepComboPage.prototype.modifierClicked = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ois, params, popup;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.modifierShown)
                            return [2 /*return*/];
                        ois = this.builder.build();
                        console.log('modifierClicked');
                        params = { store: this.store, orderitem: ois, edit: true };
                        return [4 /*yield*/, this.modalController.create({ component: ModifierItemSelectPageModal, componentProps: params })];
                    case 1:
                        popup = _a.sent();
                        popup.onDidDismiss().then(function (data) {
                            _this.modifierShown = false;
                            _this.checkAutoPickupModifierCompleted();
                            _this.cd.detectChanges();
                        });
                        popup.present().then(function (data) {
                            _this.modifierShown = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiStepComboPage.prototype.preOpenTitleGroup = function (groupId, overwrite) {
        console.log('preOpenTitleGroup');
        /*const tmp = this.hasItemTitleGroup[groupId];
        if (tmp) {
            this.isTitleGroupExpand[groupId][tmp.title] = false;
            this.titleGroupClicked(tmp.title, tmp.index, groupId, isOpeningGroupCell);

        } else*/
        if (this.titles[groupId] && this.titles[groupId].length > 0) {
            for (var i = 0; i < this.titles[groupId].length; i++) {
                this.titleGroupClicked(this.titles[groupId][i], i, groupId, overwrite);
            }
        }
    };
    // noNeed
    MultiStepComboPage.prototype.clickedNoNeed = function (group, index) {
        if (this.noNeedConfirm[group.id]) {
            return;
        }
        var groupIndex = this.groups.indexOf(group) + 1;
        console.log('group clickedNoNeed: ', groupIndex, group);
        console.log('this.builder', this.builder.groups[groupIndex]);
        var quantities = null;
        if (this.builder.groups[groupIndex] && this.builder.groups[groupIndex].items && this.builder.groups[groupIndex].items.length) {
            quantities = 0;
            // quantities = quantities + this.builder.getQuantity
            for (var _i = 0, _a = this.builder.groups[groupIndex].items; _i < _a.length; _i++) {
                var item = _a[_i];
                quantities = quantities + this.builder.getQuantityInGroup(groupIndex, item.id);
            }
            console.log('check quantities', quantities);
        }
        this.noNeedConfirm[group.id] = true;
        this.builder.clearItems(groupIndex);
        this.builder.build();
        this.isExpand[group.id] = false;
        // console.log("this.displayGroups[index-1]", this.displayGroups[index-1]);
        // for checking next group
        // TODO: go to next incomplete group
        var itemGroup = this.groups[index + 1];
        console.log('checking next itemGrp', this.groups, index + 1);
        if (itemGroup) {
            this.isExpand[itemGroup.id] = true;
        }
        // this.checkingGroupCompleted(groupIndex);
        this.updateSelectedModifier();
        // this.next();
    };
    MultiStepComboPage.prototype.addToCartClicked = function () {
        var _this = this;
        this.googleAnalyticEventTrack('add to cart');
        console.log(this.groups);
        console.log('isCompletedisCompleted', this.isCompleted());
        console.log('isAutoPickupModifierCompletedisAutoPickupModifierCompleted', this.isAutoPickupModifierCompleted);
        if (!this.isCompleted() || !this.isAutoPickupModifierCompleted) {
            // let checked = false;
            this.missing = true;
            for (var i = 0; i < this.groups.length; i++) {
                this.isExpand[this.groups[i].id] = !this.isGroupCompleted(this.groups[i]);
            }
            // TODO: scroll to the first incomplete group
            this.showNotCompletedAlert();
            return;
        }
        this.missing = false;
        var oi = this.builder.build();
        oi.combo = true;
        var orderManager;
        if (this.multOrderManager.enableMutlOrder) {
            orderManager = this.multOrderManager.getOrderManager(this.store.id);
        }
        else {
            orderManager = this.orderManager;
        }
        // const handler = this.getNavParams('handler');
        var handler = this.modalNavParams.get('multi_handler');
        if (!handler) {
            if (this.edit) {
                // this.orderService.replaceOrderItem(this.edit, this.category, igs);
                orderManager.replaceOrderItem(this.edit, oi);
                this.dismissCallback && this.dismissCallback();
            }
            else {
                // this.orderService.addSet(this.category, igs);
                orderManager.addOrderItem(oi);
            }
        }
        if (orderManager.store.menu && orderManager.store.menu.quickCheckout || handler) {
            this.modalController.dismiss().then(function () {
                // this.pushByUrl(this.multOrderManager.enableMutlOrder ? RouteTable['MultiOrderCartPage'] : RouteTable['CartPage'], {}, {replaceUrl: true}).then(
                _this.pushByUrl(_this.multOrderManager.enableMutlOrder ? RouteTable['MultiOrderCartPage'] : RouteTable['CartPage'], {}).then(function () {
                    // find index of home page, and remove from home page
                    var page;
                    var catLayout = _this.settings.catLayout;
                    /*if (this.orderService.isBK) {
                        page = CategoryItemListPage;
                    } else {
                        let noneBKPage: any;
                        if (catLayout === 'showAll') {
                            noneBKPage = CategoryItemListPage;

                        } else if (!catLayout || catLayout === 'none') {

                            noneBKPage = ItemGridPage;

                        } else {

                            noneBKPage = CategoryListPage;
                        }

                        // page = this.edit ? (this.multOrderManager.enableMutlOrder ? BrandStoreListPage : noneBKPage) : noneBKPage;
                    }*/
                    // TODO: remove history
                    // const index: number = this.navController.getViews().findIndex(
                    //     view => (view.instance instanceof (page))
                    // );
                    // const current: number = this.navController.getActive().index;
                    // console.log('views:' + this.navController.getViews()[0]);
                    // console.log('index:' + index);
                    // console.log('current:' + current);
                    // this.navController.remove(index + 1, (current - 1) - index);
                    if (handler) {
                        handler(oi);
                    }
                });
            });
        }
        else {
            this.modalController.dismiss();
            // this.navigationService.popPage();
        }
    };
    MultiStepComboPage.prototype.isAutoPickGroup = function (group, items) {
        if (items) {
            return group.min === group.max && items.length === group.min;
        }
        else {
            var availableItems = group.items;
            return group.min === group.max && availableItems.length === group.min;
        }
    };
    // new thing
    MultiStepComboPage.prototype.flatten = function () {
        var _this = this;
        var i = 0;
        // let y = 0;
        console.log(this.groups);
        var _loop_1 = function (group) {
            var items = [];
            // get all available items of the given group
            var mainItems = this_1.menuManager.getAvailableItems(this_1.store, this_1.category, group, this_1.orderManager.isTakeout());
            group.items = mainItems;
            // let isSet = false;
            // init status for title group
            this_1.isTitleGroupExpand[group.id] = {};
            // make a copy of itemGroupMap with some special value?
            var modifiedItems = [];
            var isAutoPickupGroup = this_1.isAutoPickup && this_1.isAutoPickGroup(group, mainItems);
            if (isAutoPickupGroup) {
                this_1.autoPickupGroups.push(group);
            }
            else {
                this_1.nonAutoPickupGroups.push(group);
            }
            if (mainItems && mainItems.length > 0) {
                mainItems.forEach(function (item, index) {
                    // item['groupIndex'] = i + 1;
                    // for variations?
                    /* if (item.variations && item.variations.length > 0) {
                             console.log('wtf is variations');
                             item.variations = item.variations.filter((vartion) => {
                                     vartion['groupIndex'] = item['groupIndex'];
                                     if (this.itemMap[vartion.id]) {
                                             return false;
                                     } else {
                                             this.itemMap[vartion.id] = vartion;
                                             return true;

                                     }
                             });

                     }
                     */
                    // put all itemGroupMap in itemMap
                    _this.itemMap[item.id] = item;
                    // if not edit mode and should do auto pickup
                    if (isAutoPickupGroup && !_this.edit) {
                        console.log('auto pick group', group);
                        _this.addClicked(item, group, false, true);
                        // isSet = true;
                    }
                });
                // handle drinks
                modifiedItems = this_1.groupingTitle(group, mainItems);
                // if (this.edit) {
                //         if (!(group.min === group.max && mainItems.length === group.min && this.isAutoPickup) || !this.isAutoPickup) {
                //                 group['isAutopickUp'] = true; // show item
                //         } else {
                //         }
                // } else {
                // if (!this.isGroupCompleted(group) || !this.isAutoPickup) {
                // } else if (group.optional === false) {
                //         // 因為auto pickup 出錯，特定條件下會把item group一些 un-available itemGroupMap 都pickup 起來,应该忽略optional === true 的 item group
                //
                // }
                // }
                items.push.apply(items, modifiedItems);
            }
            if (this_1.preselectItem && !this_1.edit) {
                var preselectItem = null;
                // if (this.store.pos.type !== "eats365") preselectItem = mainItems[0];
                if (group.defaultId && this_1.itemMap[group.defaultId]) {
                    preselectItem = this_1.itemMap[group.defaultId];
                    if (preselectItem) {
                        // if (!this.isSoldout(preselectItem[i], this.category)) {
                        if (!this_1.isSoldout(preselectItem, this_1.category)) {
                            this_1.addClicked(preselectItem, group, false, true);
                            this_1.addOrderItemMap(group, preselectItem[0]);
                        }
                    }
                }
                else if ((!(group.min === 0) && !group.optional)) {
                    // if there is no default item, it is not optional and group min > 0
                    // do not pick
                    // preselectItem = mainItems[0];
                    // if (preselectItem) {
                    //     this.addClicked(preselectItem, false);
                    // }
                }
                else {
                    // pick no need
                    // let groupIndex = this.groups.indexOf(group) + 1;
                    // console.log('#group clickedNoNeed: ', groupIndex, group);
                    // this.builder.clearItems(groupIndex);
                    // this.builder.build();
                    // this.checkingGroupCompleted(groupIndex);
                }
            }
            this_1.itemGroupMap[group.id] = items;
            if (this_1.sameTitleItems[group.id]) {
                for (var key in this_1.sameTitleItems[group.id]) {
                    var index = this_1.titles[group.id].indexOf(key);
                    this_1.isTitleGroupExpand[group.id][key] = false;
                    // this.titleGroupClicked(key, index, group.id);
                }
                // for (const key in this.isTitleGroupExpand[group.id]) {
                //     console.log('loop title expand?', this.isTitleGroupExpand);
                //     if (this.isTitleGroupExpand[group.id][key]) {
                //         const index = this.titles[group.id].indexOf(key);
                //         this.hasItemTitleGroup[group.id] = {title: key, index: index};
                //         this.titleGroupClicked(key, index, group.id);
                //     }
                // }
                // init sub item groups
            }
            if (!this_1.isGroupCompleted(group) || !this_1.isNoNeedSelected(group)) {
                this_1.isExpand[group.id] = true;
            }
            i++;
        };
        var this_1 = this;
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            _loop_1(group);
        }
        console.log(this.itemGroupMap);
    };
    MultiStepComboPage.prototype.addOrderItemMap = function (group, item) {
        if (!group || !item) {
            return;
        }
        if (!this.orderMap.has(group.id)) {
            this.orderMap.set(group.id, []);
        }
        this.orderMap.get(group.id).push(item.name);
        this.updateOrderMap(group.id);
    };
    MultiStepComboPage.prototype.updateOrderMap = function (id) {
        var newOrderArr = Object.assign([], this.orderMap.get(id));
        this.orderMap.set(id, newOrderArr);
    };
    MultiStepComboPage.prototype.groupingTitle = function (group, items) {
        var tmp = [];
        this.sameTitleItems[group.id] = {};
        this.titles[group.id] = [];
        var _loop_2 = function (item) {
            if (item.variations && item.variations.length > 0) {
                this_2.titles[group.id].push(item.title);
                this_2.sameTitleItems[group.id][item.title] = [item].concat(item.variations);
            }
            else if (item.group) {
                var title_1 = item.group;
                // if any items has sub group field
                if (this_2.titles[group.id].findIndex(function (t) { return title_1 === t; }) === -1) {
                    // save sub group title
                    this_2.titles[group.id].push(title_1);
                }
                // push item to sub item groups under groupId.title
                if (!this_2.sameTitleItems[group.id][title_1]) {
                    this_2.sameTitleItems[group.id][title_1] = [item];
                }
                else {
                    this_2.sameTitleItems[group.id][title_1].push(item);
                }
                var index = tmp.findIndex(function (tmpItem) { return tmpItem.id === item.id; });
                if (index !== -1) {
                    tmp.splice(index, 1);
                }
            }
            else {
                tmp.push(item);
            }
        };
        var this_2 = this;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            _loop_2(item);
        }
        return tmp;
    };
    MultiStepComboPage.prototype.getQuantity = function (item, group) {
        var qty = this.builder.getQuantityInGroup(this.getGroupIndex(group), item.id);
        return qty;
    };
    MultiStepComboPage.prototype.has = function (item, group) {
        return this.getQuantity(item, group) > 0;
    };
    MultiStepComboPage.prototype.add = function (item, group, isPreselect) {
        var _this = this;
        if (isPreselect === void 0) { isPreselect = false; }
        var oi;
        var groupIndex = this.getGroupIndex(group);
        if (groupIndex === -1) {
            groupIndex = this.groups.findIndex(function (g) {
                // TODO: is compared by id safe?
                return (g !== null && g !== undefined && g.id === group.id);
            }) + 1;
        }
        var isOptional = group.min === 0;
        if (this.getGroupMode(group) === 'single') {
            var max = group.max;
            var able = true;
            if (max >= 1) {
                var count = this.totalQuantity(groupIndex);
                if (count >= max && max !== 1) {
                    able = false;
                }
            }
            if (max === 1 && !this.has(item, group)) {
                this.builder.clearItems(groupIndex);
            }
            if (able && !this.has(item, group)) {
                this.builder.plusItem(group, item, groupIndex);
                oi = this.builder.build();
            }
            else if (this.has(item, group)) {
                this.discard(item, group);
            }
            if (!isPreselect) {
                if (this.isGroupCompleted(group)) {
                    this.handlingModifier(oi, group, this.itemMap, function () {
                        // if (this.groups[index]) {
                        _this.toggleGroupExpansion(group.id);
                        // console.log('close' + group.id);
                        // if next incomplete group exists, expand it
                        for (var i = groupIndex; i < _this.groups.length; i++) {
                            if (_this.groups[i].id === group.id && _this.isGroupCompleted(_this.groups[i])) {
                                _this.toggleGroupExpansion(_this.groups[groupIndex].id);
                                break;
                            }
                        }
                        // if (group && this.isGroupCompleted(group)) { //？？？
                        //     this.toggleGroupExpansion(group.id);
                        // }
                        // ???
                        //         this.toggleGroupExpansion(this.groups[index - 1].id);
                        //         this.toggleGroupExpansion(this.groups[index].id);
                        // }
                    }, function () {
                        _this.minusClicked(item, group);
                    });
                }
                else if (isOptional) {
                    var realItem = this.itemMap[item.id];
                    if (realItem.mgroups && realItem.mgroups.length > 0) {
                        this.handlingModifier(oi, group, this.itemMap, function () {
                        }, function () {
                            _this.minusClicked(item, group);
                        }, true);
                    }
                }
            }
        }
        else if (this.getGroupMode(group) === 'quantity') {
            var max = group.max;
            if (max <= this.totalQuantity(groupIndex)) {
                console.log('max reached');
                this.toggleGroupExpansion(group.id);
                return;
            }
            this.builder.plusItem(group, item, groupIndex);
            oi = this.builder.build();
            if (!isPreselect) {
                if (this.isGroupCompleted(group)) {
                    this.handlingModifier(oi, group, this.itemMap, function () {
                        if (_this.groups[groupIndex]) {
                            var currentQty = _this.totalQuantity(groupIndex);
                            if (_this.groups[groupIndex - 1].max === _this.groups[groupIndex - 1].min) {
                                _this.toggleGroupExpansion(_this.groups[groupIndex - 1].id);
                                _this.toggleGroupExpansion(_this.groups[groupIndex].id);
                            }
                            else if ((_this.groups[groupIndex - 1].max !== _this.groups[groupIndex - 1].min && currentQty === _this.groups[groupIndex - 1].max
                                && _this.groups[groupIndex - 1].max !== 99)) {
                                _this.toggleGroupExpansion(_this.groups[groupIndex - 1].id);
                                _this.toggleGroupExpansion(_this.groups[groupIndex].id);
                            }
                        }
                    }, function () {
                        var tmpItems = [];
                        for (var _i = 0, _a = oi.groups[groupIndex].items; _i < _a.length; _i++) {
                            var item_1 = _a[_i];
                            for (var i = 0; i < item_1.quantity; i++) {
                                tmpItems.push(_this.itemMap[item_1.id]);
                            }
                        }
                        for (var _b = 0, tmpItems_1 = tmpItems; _b < tmpItems_1.length; _b++) {
                            var item_2 = tmpItems_1[_b];
                            _this.minusClicked(item_2, group);
                        }
                    });
                }
                else if (isOptional) {
                    var realItem = this.itemMap[item.id];
                    if (realItem.mgroups && realItem.mgroups.length > 0) {
                        this.handlingModifier(oi, group, this.itemMap, function () {
                        }, function () {
                            _this.minusClicked(item, group);
                        }, true);
                    }
                }
            }
        }
    };
    MultiStepComboPage.prototype.titleGroupClicked = function (title, index, groupId, overwrite) {
        var childNode = document.getElementById('child-' + groupId + '-' + index);
        if (this.isTitleGroupExpand[groupId]) {
            if (overwrite) {
                this.isTitleGroupExpand[groupId][title] = overwrite === 1;
            }
            else {
                this.isTitleGroupExpand[groupId][title] = !this.isTitleGroupExpand[groupId][title];
            }
            if (childNode) {
                childNode.style.maxHeight = this.isTitleGroupExpand[groupId][title] ? childNode.scrollHeight + 'px' : '0px';
            }
        }
        // let currentStatus = this.isTitleGroupExpand[groupId][title];
        // if (this.openedTitleGroup && this.openedTitleGroup !== {}) {
        //     this.isTitleGroupExpand[groupId][title] = false;
        //     this.openedTitleGroup['childNode'].style.maxHeight = '0px';
        // }
        // if (this.openedTitleGroup && this.openedTitleGroup['title'] === title) {
        //     const needReturn = this.openedTitleGroup['groupId'] === groupId;
        //     this.openedTitleGroup = null;
        //     if (needReturn && !isOpeningGroupCell) {
        //         return;
        //     }
        // }
        // // this.isTitleGroupExpand[title] = !this.isTitleGroupExpand[title];
        // const childNode = document.getElementById('child-' + groupId + '-' + index);
        // if (this.isTitleGroupExpand[groupId][title]) {
        //     this.isTitleGroupExpand[groupId][title] = false;
        //     this.openedTitleGroup = null;
        //     childNode.style.maxHeight = '0px';
        // } else if (this.titles[groupId].length === 1) {
        //     this.isTitleGroupExpand[groupId][title] = true;
        //     childNode.style.maxHeight = childNode.scrollHeight + 'px';
        //     this.openedTitleGroup = {childNode: childNode, title: title, groupId: groupId};
        //
        // } else {
        //     this.isTitleGroupExpand[groupId][title] = true;
        //     childNode.style.maxHeight = childNode.scrollHeight + 'px';
        //     this.openedTitleGroup = {childNode: childNode, title: title, groupId: groupId};
        //
        // }
    };
    MultiStepComboPage.prototype.addClicked = function (item, group, detectChanges, isPreselect) {
        if (detectChanges === void 0) { detectChanges = true; }
        if (isPreselect === void 0) { isPreselect = false; }
        // to do
        // this.googleAnalyticEventTrack("add-item", item.name);
        var groupId = group.id;
        if (this.noNeedConfirm && this.noNeedConfirm[groupId])
            delete this.noNeedConfirm[groupId];
        console.log('addClicked');
        if (this.isSoldout(item)) {
            console.log('item sold out, return', item);
            return;
        }
        console.log('page点击传递的参数', item, group, isPreselect);
        this.add(item, group, isPreselect);
        this.handleModifier();
        if (detectChanges) {
            this.cd.detectChanges();
        }
        console.log('build', this.builder);
        // fixed: 取消選擇後, css 要回到未選擇時的style
        // this.checkingGroupCompleted(this.getItemRealGroupIndex(item));
    };
    MultiStepComboPage.prototype.discard = function (item, group) {
        /* if (this.quantityMap[item.id] && this.quantityMap[item.id] > 0) {
            this.quantityMap[item.id]--;
        } */
        this.builder.minusItem(null, item, this.getGroupIndex(group));
        this.builder.build();
    };
    MultiStepComboPage.prototype.minusClicked = function (item, group) {
        console.log('minusClicked');
        // to do
        // this.googleAnalyticEventTrack("click", "minus-button");
        this.discard(item, group);
        // this.checkingGroupCompleted(item['groupIndex']);
        this.handleModifier();
        if (this.cd) {
            this.cd.detectChanges();
        }
    };
    MultiStepComboPage.prototype.pageName = function () {
        return '/multi-step-combo';
    };
    MultiStepComboPage.prototype.numberToFixed = function (number) {
        if ('HKD' === this.orderService.currency) {
            return Number(number.toFixed(1));
        }
        else if ('CNY' === this.orderService.currency) {
            return Number(number.toFixed(1));
        }
        else if ('SGD' === this.orderService.currency) {
            return Number(number.toFixed(2));
        }
        else {
            return Number(number.toFixed(1));
        }
    };
    MultiStepComboPage.prototype.matchingGroupIndex = function (oi) {
        var groups = oi.groups;
        if (groups.length !== this.builderGroupsCount && groups.length - 1 <= this.groups.length) {
            this.groupIdMap = {};
            for (var i = 0; i < groups.length; i++) {
                this.groupIdMap[groups[i].id] = i;
            }
        }
        this.builderGroupsCount = groups.length;
    };
    MultiStepComboPage.prototype.updateSelectedModifier = function () {
        var _this = this;
        var oi = this.builder.build();
        var modifiers = [];
        var total = 0;
        oi.groups.forEach(function (group) {
            var items = group.items;
            items.forEach(function (item) {
                total = _this.numberToFixed(total + item.price * item.quantity);
            });
            items.filter(function (item) { return item.mgroups && item.mgroups.length > 0; }).forEach(function (item) {
                var mgroups = item.mgroups;
                mgroups.forEach(function (mgroup) {
                    modifiers = modifiers.concat(mgroup.items);
                });
            });
        });
        modifiers = modifiers.filter(function (item) { return item.quantity > 0; });
        modifiers.forEach(function (item) {
            total = _this.numberToFixed(total + item.price * item.quantity);
        });
        console.log('update price');
        this.total = total;
    };
    MultiStepComboPage.prototype.handleModifier = function () {
        var oi = this.builder.build();
        this.currentOrderItem = oi;
        var modifiable = this.modifierBuilder.findItems(oi);
        this.modifiable = modifiable.length > 0;
        this.matchingGroupIndex(this.currentOrderItem);
        console.log('modifiable?', this.modifiable, modifiable);
        this.updateSelectedModifier();
    };
    MultiStepComboPage.prototype.totalQuantity = function (groupIndex) {
        return this.builder.getChoices(groupIndex);
    };
    MultiStepComboPage.prototype.isCompleted = function () {
        // const groups: ItemGroup[] = this.builder.groups;
        // index 0 is main group, which must has an selected item
        for (var i = 0; i < this.groups.length; i++) {
            /*
            * Suppose now there are 5 groups and they are [A, B, C, D, E] and A is the main group,
            * this.groups is an array [B, C, D, E],
            * builder.groups is an array with groups which have selected itemGroupMap, says [A, B, C, (null), (null)]
            *
            * then we check this.groups one by one (except main group)
            * if this.groups[i] is not optional
            * builder.groups[i + 1] must has an selected item
            * if not, then it is incompleted
            */
            if (!this.isGroupCompleted(this.groups[i])) {
                return false;
            }
            if (!this.isRequiredModifierSelect(i)) {
                return false;
            }
        }
        return true;
    };
    MultiStepComboPage.prototype.showNotCompletedAlert = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subtitle, confirm, alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subtitle = this.t.instant('pages.set-select.select-error');
                        confirm = this.t.instant('buttons.ok');
                        return [4 /*yield*/, this.alertController.create({
                                message: subtitle,
                                buttons: [confirm]
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiStepComboPage.prototype.getBuilderGroup = function (group) {
        return this.builder.groups.find(function (g) {
            return (g !== null && g !== undefined && g.id === group.id);
        });
    };
    MultiStepComboPage.prototype.getSelectedItemNamesArr = function (group) {
        var itemGroup = this.getBuilderGroup(group);
        if (!itemGroup) {
            return [];
        }
        if (this.isNoNeedSelected(group)) {
            return [];
            // return this.t.instant('pages.item-select.no-need');
        }
        var selected = itemGroup.items;
        if (!selected) {
            return [];
        }
        var arr = [];
        selected.filter(function (item) { return item.quantity > 0; }).map(function (item) {
            var qtyPart = '';
            if (item.quantity > 1) {
                qtyPart = item.quantity + 'x ';
            }
            arr.push(qtyPart + item.name);
        });
        return arr;
    };
    MultiStepComboPage.prototype.presentModifierPopup = function (store, orderItem, group, itemMap, page, handler, showLastOne) {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = { store: store, orderitem: orderItem, group: group, itemMap: itemMap };
                        if (showLastOne) {
                            input['showLastOne'] = showLastOne;
                        }
                        return [4 /*yield*/, this.modalController.create({
                                component: page,
                                componentProps: input,
                                animated: true,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen modifier-modal'
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (confirm) {
                            if (handler) {
                                handler(confirm);
                            }
                        });
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiStepComboPage.prototype.hasRequiredModifier = function (items) {
        return this.hasModifier(items, this.itemMap, true);
    };
    MultiStepComboPage.prototype.getSelectedItemNamesModifier = function (group, i) {
        //    if (this.builder.groups) return ;
        console.log('groupgroup', group);
        var itemGroup = this.builder.groups.filter(function (_group) {
            if (_group) {
                return _group.id === group.id;
            }
            else {
                return false;
            }
        })[0];
        // if (itemGroup === null) {
        //     return this.t.instant("pages.item-select.no-need");
        //     // return "不需要";
        // }
        // if (typeof itemGroup === 'undefined') {
        //     return "";
        // }
        if (!itemGroup) {
            return '';
        }
        var selected = itemGroup.items;
        if (!selected) {
            return '';
        }
        // get modifier
        var firstItem = true;
        console.log('selectedselected', selected, i);
        var output = '';
        for (var _i = 0, selected_1 = selected; _i < selected_1.length; _i++) {
            var select = selected_1[_i];
            if (select.id === i.id) {
                if (!select.mgroups)
                    continue;
                for (var _a = 0, _b = select.mgroups; _a < _b.length; _a++) {
                    var mgroup = _b[_a];
                    if (!mgroup.items)
                        continue;
                    if (select.id === i.id)
                        for (var _c = 0, _d = mgroup.items; _c < _d.length; _c++) {
                            var item = _d[_c];
                            if (firstItem) {
                                output = item.name + ' x ' + item.quantity;
                                firstItem = false;
                            }
                            else {
                                output = output + ', ' + item.name + ' x ' + item.quantity;
                            }
                        }
                    // return output;
                }
            }
        }
        return output;
    };
    MultiStepComboPage.prototype.hasModifier = function (items, itemMap, checkRequired) {
        if (checkRequired === void 0) { checkRequired = false; }
        var required = false;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            var tmpItem = itemMap[item.id];
            if (tmpItem && tmpItem.mgroups && tmpItem.mgroups.length > 0) {
                if (checkRequired) {
                    for (var _a = 0, _b = tmpItem.mgroups; _a < _b.length; _a++) {
                        var mgroup = _b[_a];
                        if (mgroup.min && mgroup.min > 0) {
                            required = true;
                            break;
                        }
                    }
                }
                else {
                    required = true;
                    break;
                }
            }
        }
        return required;
    };
    MultiStepComboPage.prototype.isRequiredModifierSelect = function (index) {
        var _this = this;
        var oi = this.currentOrderItem ? this.currentOrderItem : this.builder.build();
        this.currentOrderItem = oi;
        var tmpIndex = index + 1;
        var group = oi.groups[tmpIndex];
        if (group && this.hasRequiredModifier(group.items)) {
            var builderItems = group.items;
            var selected = !builderItems.some(function (item) {
                var builderMgroups = item.mgroups;
                var mgroups = _this.itemMap[item.id].mgroups;
                if (mgroups) {
                    for (var i = 0; i < mgroups.length; i++) {
                        if (mgroups[i].items && mgroups[i].items.length === 0) {
                            continue;
                        }
                        if (builderMgroups) {
                            for (var _i = 0, builderMgroups_1 = builderMgroups; _i < builderMgroups_1.length; _i++) {
                                var b = builderMgroups_1[_i];
                                if (b.id === mgroups[i].id && mgroups[i].min > 0) {
                                    var quantity = 0;
                                    for (var _a = 0, _b = b.items; _a < _b.length; _a++) {
                                        var t = _b[_a];
                                        quantity += 1 * t.quantity;
                                    }
                                    return !(quantity >= mgroups[i].min);
                                }
                            }
                        }
                        // if (builderMgroups && builderMgroups[i] && mgroups[i].min > 0) {
                        //     let quantity = 0;
                        //     for (const t of builderMgroups[i].items) {
                        //         quantity += 1 * t.quantity;
                        //     }
                        //     return !(quantity >= mgroups[i].min);
                        // } else if ((!builderMgroups || !builderMgroups[i])) {
                        //     return mgroups[i].min > 0;
                        // }
                    }
                }
                else {
                    return false;
                }
            });
            return selected;
        }
        else {
            return true;
        }
    };
    MultiStepComboPage.prototype.isGroupCompleted = function (group) {
        // console.log(group);
        if (!group) {
            return true;
        }
        var index = this.getGroupIndex(group);
        var quantity = this.totalQuantity(index);
        if (group.min <= quantity || quantity === group.max) {
            return true;
        }
        if (group.optional) {
            if (group.skippable) {
                return true;
            }
            else {
                return index === -1;
            }
        }
        return false;
    };
    MultiStepComboPage.prototype.isNoNeedSelected = function (group) {
        return this.noNeedConfirm[group.id] && this.getGroupIndex(group) === -1;
    };
    MultiStepComboPage.prototype.getGroupIndex = function (group) {
        return this.builder.groups.findIndex(function (g) {
            // TODO: is compared by id safe?
            return (g !== null && g !== undefined && g.id === group.id);
        });
    };
    MultiStepComboPage.prototype.handlingModifier = function (oi, realGroup, itemMap, addHandler, notAddHandler, showLastOne) {
        if (showLastOne === void 0) { showLastOne = false; }
        if (!oi) {
            return;
        }
        var group = oi.groups.find(function (g) { return g.id === realGroup.id; });
        group = oi.groups.find(function (g) { return g.id === realGroup.id; });
        if (this.hasRequiredModifier(group.items)) {
            this.presentModifierPopup(this.store, oi, group, itemMap, ModifierDialog, function (confirm) {
                if (confirm && confirm['data']) {
                    addHandler();
                }
                else {
                    notAddHandler(group);
                }
            }, showLastOne);
        }
        else {
            addHandler();
        }
    };
    MultiStepComboPage.prototype.getGroupMode = function (group) {
        return group.repeat ? 'quantity' : 'single';
    };
    MultiStepComboPage.prototype.isCurrentGroupHasModifier = function (group, map) {
        var index = this.groupIdMap[group.id];
        var g = this.currentOrderItem && this.currentOrderItem.groups ? this.currentOrderItem.groups[index] : null;
        if (g) {
            var has = this.hasModifier(g.items, this.itemMap);
            if (map) {
                map[g.id] = has;
            }
            return has;
        }
        else {
            return false;
        }
    };
    MultiStepComboPage.prototype.showModifierPopup = function (group) {
        var _this = this;
        var oi = this.builder.build();
        var index = this.groupIdMap[group.id];
        var g = oi.groups[index];
        if (this.hasModifier(group.items, this.itemMap)) {
            this.presentModifierPopup(this.store, oi, g, this.itemMap, ModifierDialog, function (result) {
                _this.handleModifier();
                _this.cd.detectChanges();
            });
        }
    };
    MultiStepComboPage.prototype.settingMultOrderManager = function () {
        if (this.multOrderManager.getOrderManager(this.store.id)) {
            this.orderManager = this.multOrderManager.getOrderManager(this.store.id);
        }
        else {
            var orderManager = new OrderManager();
            orderManager.createOrder(this.store.id, null, null, null, this.store);
            this.multOrderManager.setOrderManagerMap(orderManager, this.store.id);
            this.orderManager = this.multOrderManager.getOrderManager(this.store.id);
        }
    };
    return MultiStepComboPage;
}(MobileBasePage));
export { MultiStepComboPage };
